import { useEffect, useState } from "react";

/** Keystrokes are cheap; round-trips aren't — only the settled value hits the API. */
export function useDebounced(value: string, delayMs = 250) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
